import config from '@/lib/config';
import TaggedActivity from '../templates/metrics/TaggedActivity';

const StrategicImportance = new TaggedActivity({
  name: 'StrategicImportance',
  tag: config.INSIGHTS.TAGS.STRATEGIC_IMPORTANCE,
});

export default StrategicImportance;
